import { Button } from '@material-ui/core'
import styled, { css } from 'styled-components'

import { buttonStyles, LinkPrimaryButton, LinkSecondaryButton } from '../../../../global/LinkButton'
import { RewardsCard } from '../RewardsCard'
import { RewardsHeading2 } from '../RewardsHeading'

export const DetailsPayoutsCard = styled(RewardsCard)`
  border-color: ${({ theme }) => theme.colors.coolGray.cool300};
  border-width: 1px;
  border-radius: 4px;
  margin-top: 32px;
  min-height: 216px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`

export const DetailsPayoutsCardHeading = styled(RewardsHeading2)`
  font-size: 22px;
`

export const DetailsPayoutsCardContent = styled.div`
  flex-grow: 1;
  width: 100%;
`

export const DetailsPayoutsCardAmountLabel = styled.div`
  margin-top: 14px;
  font-size: 16px;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const DetailsPayoutsCardAmount = styled.span`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
  margin-right: 5px;
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const DetailsPayoutsCardAmountSubtext = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 0;
  margin-top: 10px;
`

export const DetailsPayoutsCardActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  width: 100%;
  @media (min-width: 1280px) {
    flex-direction: row;
    width: auto;
  }
`

const buttonsStyles = css`
  --btn-height: 36px;
  height: auto;
  width: 100%;
  min-width: 165px;
  text-transform: none;

  &:hover {
    text-decoration: none;
  }
`

const primaryButtonStyles = css`
  ${buttonsStyles};
  font-size: 18px;
  background-color: ${({ theme }) => theme.colors.component.PrimaryButton.default.background};

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.PrimaryButton.hover.background};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.component.PrimaryButton.disabled.background};
  }

  @media (min-width: 1280px) {
    width: 150px;
  }
`

export const DetailsPayoutsCardPrimaryButton = styled(Button)`
  ${primaryButtonStyles};
  color: ${({ theme }) => theme.colors.component.PrimaryButton.default.text};
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
`

export const DetailsPayoutsCardPrimaryButtonLink = styled(LinkPrimaryButton)`
  ${primaryButtonStyles};
`

const secondaryButtonStyles = css`
  ${buttonStyles({ height: 36 })};
  ${buttonsStyles};
  font-size: 16px;
  border: ${(props) => `1px solid ${props.theme.colors.brand.blue}`};
  background-color: ${({ theme }) => theme.colors.component.SecondaryButton.default.background};

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.background};
    color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.text};
  }

  &:disabled {
    pointer-events: auto;
    color: rgba(0, 0, 0, 0.26);
  }
`

export const DetailsPayoutsCardSecondaryButton = styled(Button)`
  ${secondaryButtonStyles};
  color: ${({ theme }) => theme.colors.component.SecondaryButton.default.text};
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
`

export const DetailsPayoutsCardSecondaryButtonLink = styled(LinkSecondaryButton)`
  ${secondaryButtonStyles};
`
